// Stable accessor for the logged-in person row + derived fields.
// The auth response carries `person` as a SQL recordset array; useCurrentPerson
// unwraps `person[0]` and memoises a flat shape so consumers don't repeat the
// optional-chain pattern at every call site and don't break referential
// equality on every render.

import { useMemo } from "react";
import { useAuth } from "src/context/AuthContext";

export function useCurrentPerson() {
    const { user } = useAuth();
    return useMemo(() => {
        const p = user?.person?.[0];
        if (!p) return null;
        const firstName = p.personFirstName ?? "";
        const lastName = p.personLastName ?? "";
        return {
            personId: p.personId ?? null,
            firstName,
            lastName,
            fullName: `${firstName} ${lastName}`.trim(),
            email: p.personEmail ?? "",
            phone: p.personPhone ?? "",
            ownerAsiakasId: p.ownerAsiakasId ?? null,
        };
    }, [user]);
}
